var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagLesotho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2713C0 18.7645 0.570438 21.1243 1.58763 23.2278L16 23.9235L30.4124 23.2279C31.4296 21.1243 32 18.7645 32 16.2713C32 13.7782 31.4296 11.4183 30.4124 9.31483L16 8.61914L1.58763 9.31477C0.570438 11.4183 0 13.7782 0 16.2713H0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 32.2715C22.3436 32.2715 27.8246 28.58 30.4126 23.228H1.58789C4.17589 28.58 9.65689 32.2715 16.0003 32.2715Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.271484C9.65689 0.271484 4.17589 3.96305 1.58789 9.31498H30.4126C27.8246 3.96305 22.3436 0.271484 16.0003 0.271484Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0431 15.9237V12.0977H14.9562V15.9237L12.4355 18.4444C13.1686 19.6444 14.4905 20.4455 15.9997 20.4455C17.5088 20.4455 18.8307 19.6444 19.5638 18.4444L17.0431 15.9237Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.271484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLesotho);
export default __webpack_public_path__ + "static/media/flag_lesotho.44bc4b6af936e988a7b86cc7ec667d6d.svg";
export { ForwardRef as ReactComponent };